import { KPI_ADD_UPDATE } from 'constants/actionTypes';

export function addUpdateKpi(kpiEntry) {
  return {
    type: KPI_ADD_UPDATE,
    kpiEntry,
  };
}
